/*
 * @file handle display value attachment caption
 */

// Attachment caption can have a default value (currently it is title from Beethoven's extraction)
// If there is no custom value for attachment caption set in the post, we will display that default value

const attachmentCaptionForDisplay = ({
  postAttachmentCaption,
  defaultCaption,
}: {
  postAttachmentCaption: string | null
  defaultCaption: string
}): string => {
  return postAttachmentCaption || defaultCaption || ''
}

export default attachmentCaptionForDisplay
